import {Container, Logo, Wrap} from "./styled";
import { useFooter, useImageUrl } from "../../../queries";

export const Footer = () => {
    const {data: footer} = useFooter();
    const data = footer?.[0] || {};
    const imageUrl = useImageUrl(data?.image);

    return (
        <Container>
            <Wrap>
                <Logo src={imageUrl || ""}/>
            </Wrap>
        </Container>
    )
}
